import React from "react";
import ReactEcharts from "echarts-for-react";

const RouteDate = () => {
  const { innerWidth } = window;
  const fontSize = innerWidth > 4000 ? 24 : 12;
  const barWidth = innerWidth > 4000 ? 48 : 24;
  return (
    <ReactEcharts
      option={{
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: "rgba(0,0,0,0.08)",
            },
          },
          formatter: (params) => {
            let tar = params[1];
            return tar.name + " : " + tar.value;
          },
        },
        grid: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            axisLabel: {
              color: "rgba(255,255,255,0.75)",
              fontSize: fontSize,
              lineHeight: 16,
              end: true,
              margin: 10,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.75)",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.75)",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.35)",
              },
            },
            data: [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "rgba(255,255,255,0.75)",
              fontSize: fontSize,
              lineHeight: 16,
              end: true,
              margin: 10,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.75)",
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.75)",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.35)",
              },
            },
            min: 0,
            max: 365,
          },
        ],
        series: [
          {
            name: "Auxiliary", //空白堆叠部分
            type: "bar",
            stack: "total",
            itemStyle: {
              color: "rgba(255,0,0,0)",
            },
            barWidth: barWidth,
            data: [218, 231, 222, 208, 222, 202, 220, 205, 200, 223],
          },
          {
            name: "Number",
            type: "bar",
            stack: "total",
            itemStyle: {
              color: (params) => {
                let colorList = [
                  "#1a7ab6",
                  "#f77d0e",
                  "#2a9c2a",
                  "#da2325",
                  "#9367bc",
                  "#8e5645",
                  "#e774bf",
                  "#808080",
                  "#bbba2c",
                  "#4A235A",
                  "#C39BD3",
                  "#F9E79F",
                  "#BA4A00",
                  "#ECF0F1",
                  "#616A6B",
                  "#EAF2F8",
                  "#4A235A",
                  "#3498DB",
                ];
                return colorList[params.dataIndex];
              },
            },
            label: {
              show: true,
              position: "inside",
              color: "rgba(255,255,255,0.75)",
              fontSize: fontSize,
            },
            barWidth: barWidth,
            data: [78, 50, 62, 81, 74, 83, 76, 101, 114, 79],
          },
        ],
      }}
      lazyUpdate={true}
      style={{
        height: "100%",
        width: "100%",
      }}
    />
  );
};

export default RouteDate;
